import React, { useState } from "react";
import { Button, Form, Modal } from "semantic-ui-react";

const DeleteAppDetail = ({
  openDeleteModal,
  setOpenDeleteModal,
  onSaveUpdateApp,
  appDetail,
  setAppFormData,
}) => {
  const [deleteFormData, setDeleteFormData] = useState({
    deleteText: "",
    deleteValid: true,
  });

  const initDeleteFormData = () => {
    setDeleteFormData({
      deleteText: "",
      deleteValid: true,
    });
  };

  const handleDeleteApp = () => {
    if (deleteFormData.deleteText !== appDetail.UserName) {
      setDeleteFormData({ ...deleteFormData, deleteValid: false });
      return;
    } else {
      setAppFormData({
        appName: "",
        oauthScope: [],
        appNameValid: true,
        oauthScopeValid: true,
      });
      setOpenDeleteModal(false);
      initDeleteFormData();
      const params = {
        operation: "deleteApp",
        clientId: appDetail.AppId,
        userName: appDetail.UserName,
      };
      onSaveUpdateApp(params);
    }
  };

  return (
    <Modal size="small" open={openDeleteModal}>
      <Modal.Header>Confirm deletion</Modal.Header>
      <Modal.Content>
        <p>
          You understand that by performing this action, you will delete this
          App and its associated targets, remove it from assigned profiles and
          no longer subscribe to the APIs. They will not be recoverable.
        </p>
        <p>
          Enter the <strong>{appDetail && appDetail.UserName}</strong> to
          continue.
        </p>
        <Form>
          <Form.Input
            fluid
            error={!deleteFormData.deleteValid}
            placeholder={appDetail?.UserName}
            value={deleteFormData.deleteText}
            onChange={(e, data) =>
              setDeleteFormData({ deleteText: data.value, deleteValid: true })
            }
          />
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button
          onClick={() => {
            initDeleteFormData();
            setOpenDeleteModal(false);
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={() => {
            handleDeleteApp();
          }}
          type="submit"
          negative
        >
          Save
        </Button>
      </Modal.Actions>
    </Modal>
  );
};
export { DeleteAppDetail };
